import { getTaxTypesAPI } from '../api/taxType'

export const getTaxTypes = () => {
  return getTaxTypesAPI()
    .then((response) => {
      return response
    })
    .catch()
}



// WEBPACK FOOTER //
// ./src/actions/taxType.ts